import { render } from "./OrganizationView.vue?vue&type=template&id=7cf39f61&scoped=true"
import script from "./OrganizationView.vue?vue&type=script&lang=js"
export * from "./OrganizationView.vue?vue&type=script&lang=js"

import "./OrganizationView.vue?vue&type=style&index=0&id=7cf39f61&scoped=true&lang=css"

import exportComponent from "/home/treim/code/trit/reclo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf39f61"]])

export default __exports__